import React from 'react';
import './Contact.css'

const Contact = () => {
    return (
        <div className="contact-container">
            <div>
                <h1>In Case Of Emergency Booking.</h1>
                <p>you can contact below numbers and email</p>
                <p>these numbers and email are open for emergency case</p>
                <h2>PHONE</h2>
                <p>01235421******</p>
                <p>0123533******</p>
                <p>0123530******</p>
                <p>01235372******</p>
                <h2>Email</h2>
                <p>TravleWORLD@gmail.com</p>
            </div>
        </div>
    );
};

export default Contact;